var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertiesFreeslotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1249_2902)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.802734 11.4998C0.802734 6.45701 0.802734 3.93547 2.36951 2.3687C3.93596 0.802246 6.4575 0.802246 11.5003 0.802246C16.543 0.802246 19.0645 0.802246 20.6313 2.36902C22.1981 3.93579 22.1981 6.45701 22.1981 11.5001",
    stroke: "#27A376",
    strokeMiterlimit: 133.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.802734 13.6395C0.802734 10.644 0.802734 9.14618 1.38586 8.00207C1.89871 6.99564 2.71707 6.17727 3.72351 5.66443C4.86762 5.0813 6.36539 5.0813 9.36094 5.0813H13.6399C16.6354 5.0813 18.1332 5.0813 19.2776 5.66443C20.2841 6.17727 21.1024 6.99564 21.615 8.00207C22.1981 9.14618 22.1981 10.644 22.1981 13.6395C22.1981 16.6351 22.1981 18.1328 21.615 19.2773C21.1021 20.2837 20.2841 21.1021 19.2776 21.6146C18.1335 22.1977 16.6358 22.1977 13.6399 22.1977H9.36094C6.36539 22.1977 4.86762 22.1977 3.72351 21.6146C2.71707 21.1017 1.89871 20.2837 1.38586 19.2773C0.802734 18.1331 0.802734 16.6354 0.802734 13.6395Z",
    stroke: "#27A376",
    strokeMiterlimit: 133.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82617 14.0672L10.3544 15.7787L14.1751 11.4998",
    stroke: "#27A376",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1249_2902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertiesFreeslotIcon);
export default __webpack_public_path__ + "static/media/properties-freeslot-icon.a245f1ea8675ef7818ff4017f35d3fda.svg";
export { ForwardRef as ReactComponent };